import React from 'react';
import './Terms.css';

const TermsOfService = () => {
  return (
    <div className="terms-container">
      <div className="terms-content">
        <h1>TERMS OF SERVICE — SUMMIT VISIO</h1>
        <p className="effective-date">Effective Date: 27 March 2026</p>
        
        <section>
          <h2>1. INTRODUCTION</h2>
          <p>These Terms of Service ("Terms") govern your use of the services provided by Summit Visio ("we", "us", "our"), an Agentic AI Development company based in Krugersdorp, South Africa. By engaging with our services, you agree to be bound by these Terms.</p>
        </section>

        <section>
          <h2>2. SERVICES</h2>
          <p>Summit Visio provides:</p>
          <ul>
            <li>AI Social Media Automation (content scheduling, comment/DM automation, analytics)</li>
            <li>WhatsApp AI Sales Agents (automated customer engagement, lead qualification, sales support)</li>
            <li>Custom AI agent development for businesses</li>
          </ul>
          <p>Service packages and pricing are available on request or via our WhatsApp Business channel.</p>
        </section>

        <section>
          <h2>3. ELIGIBILITY</h2>
          <p>You must be at least 18 years old and have the legal capacity to enter into a binding agreement to use our services.</p>
        </section>

        <section>
          <h2>4. SETUP AND PAYMENT</h2>
          <ul>
            <li>A once-off setup fee of R500 is required before service activation.</li>
            <li>Monthly subscription fees are billed according to your selected package.</li>
            <li>Payments are processed via Paystack (https://paystack.shop/pay/5-ntgng8ma).</li>
            <li>All fees are quoted in South African Rand (ZAR) unless otherwise stated.</li>
            <li>Fees are non-refundable unless otherwise agreed in writing by Summit Visio.</li>
          </ul>
        </section>

        <section>
          <h2>5. SERVICE ACTIVATION</h2>
          <p>Services will be activated within a reasonable time after receipt of the setup fee and completion of onboarding requirements (e.g., granting access to social media accounts or WhatsApp Business API).</p>
        </section>

        <section>
          <h2>6. CLIENT RESPONSIBILITIES</h2>
          <p>You agree to:</p>
          <ul>
            <li>Provide accurate and complete information during onboarding</li>
            <li>Grant necessary access to platforms required for service delivery</li>
            <li>Comply with the terms of service of third-party platforms (Meta, WhatsApp, Instagram, etc.)</li>
            <li>Not use our services for unlawful, fraudulent, or harmful purposes</li>
            <li>Not send spam or unsolicited messages through our AI systems</li>
          </ul>
        </section>

        <section>
          <h2>7. AI-POWERED INTERACTIONS</h2>
          <p>Our services utilise artificial intelligence to automate conversations and business processes. While we strive for accuracy and quality:</p>
          <ul>
            <li>AI responses are generated automatically and may occasionally contain errors</li>
            <li>We do not guarantee specific business results, revenue increases, or lead conversion rates</li>
            <li>A human representative is available for escalation upon request</li>
          </ul>
        </section>

        <section>
          <h2>8. INTELLECTUAL PROPERTY</h2>
          <p>All AI systems, workflows, prompts, and configurations developed by Summit Visio remain our intellectual property. You are granted a non-exclusive, non-transferable licence to use the services for the duration of your subscription.</p>
        </section>

        <section>
          <h2>9. DATA AND PRIVACY</h2>
          <p>Your use of our services is also governed by our Privacy Policy, available at summit.iglam.co.za/privacy-policy. We process personal information in accordance with POPIA.</p>
        </section>

        <section>
          <h2>10. LIMITATION OF LIABILITY</h2>
          <p>To the maximum extent permitted by South African law:</p>
          <ul>
            <li>Summit Visio shall not be liable for indirect, incidental, or consequential damages</li>
            <li>Our total liability shall not exceed the fees paid by you in the preceding 3 months</li>
            <li>We are not liable for downtime or issues caused by third-party platforms (Meta, WhatsApp, Groq, etc.)</li>
          </ul>
        </section>

        <section>
          <h2>11. SUSPENSION AND TERMINATION</h2>
          <p>We reserve the right to suspend or terminate your access to services if:</p>
          <ul>
            <li>You breach these Terms</li>
            <li>Payment is overdue</li>
            <li>Your use of services violates applicable laws or third-party platform policies</li>
          </ul>
          <p>You may cancel your subscription by providing 30 days' written notice via WhatsApp or email.</p>
        </section>

        <section>
          <h2>12. PROMOTIONS AND SPECIAL OFFERS</h2>
          <p>Promotional pricing (e.g., launch specials) is subject to specific terms and expiry dates as communicated at the time of the offer. Promotional rates apply only for the stated period.</p>
        </section>

        <section>
          <h2>13. DISPUTE RESOLUTION</h2>
          <p>Any disputes arising from these Terms shall be resolved through good-faith negotiation. If unresolved, disputes shall be submitted to mediation in Krugersdorp, South Africa, in accordance with South African law.</p>
        </section>

        <section>
          <h2>14. GOVERNING LAW</h2>
          <p>These Terms are governed by the laws of the Republic of South Africa.</p>
        </section>

        <section>
          <h2>15. CHANGES TO THESE TERMS</h2>
          <p>We may update these Terms from time to time. Continued use of our services after changes constitutes acceptance of the updated Terms.</p>
        </section>

        <section>
          <h2>16. CONTACT</h2>
          <p><strong>Business:</strong> Summit Visio</p>
          <p><strong>Owner:</strong> Samuel Adeyinka</p>
          <p><strong>Location:</strong> Krugersdorp, South Africa</p>
          <p><strong>Website:</strong> summit.iglam.co.za</p>
          <p><strong>WhatsApp:</strong> Available on our website</p>
        </section>
      </div>
    </div>
  );
};

export default TermsOfService;
